import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

/**
 * @deprecated use usePetitionDetailsPageData() instead
 */
export function useFcm() {
	const {
		data: { featureConfigs },
	} = usePetitionDetailsPageData();
	return featureConfigs;
}
